import React from 'react';
import PropTypes from 'prop-types';
import { SUMMARY_LAYOUT } from '../../constants/reportLayouts';
import ReportLayoutPage from './ReportLayoutPage'


const SummaryLayout = ({ match }) => (
  <ReportLayoutPage
    layout={SUMMARY_LAYOUT}
    reportType={match.params.type}
    companyId={match.params.companyId}
    withCoverLetter={true}
    withEndOfReport={true}
    withAttachment={true}
    coverLetterTitle={'First Page of Report'}
  />
);

SummaryLayout.propTypes = {
  match: PropTypes.object
};

export default SummaryLayout;


// WEBPACK FOOTER //
// src/components/reportLayout/SummaryLayout.jsx